import { jsxs as n, Fragment as r, jsx as o } from "../../_virtual/jsx-runtime.mjs";
import * as e from "react";
import { pic as x, img as S } from "./css/Media.css.mjs";
import N from "../../depend/classnames/index.mjs";
import { DEFAULT_SCREEN_BREAKPOINT as h } from "./const.mjs";
const j = (m) => {
  var a, t, c, i, l, s;
  const g = m.breakpoint ?? h, u = e.useMemo(() => N(
    x,
    m.commonClassName
  ), [m.commonClassName]), y = e.useMemo(
    () => ({
      ...m.commonStyle
    }),
    [m.commonStyle]
  ), d = e.useMemo(() => N(
    S,
    m.className
  ), [m.className]), f = e.useMemo(
    () => ({
      ...m.style
    }),
    [m.style]
  );
  return /* @__PURE__ */ n(r, { children: [
    /* @__PURE__ */ n(
      "picture",
      {
        style: y,
        className: u,
        children: [
          /* @__PURE__ */ o(
            "source",
            {
              srcSet: (t = (a = m.image) == null ? void 0 : a.m) == null ? void 0 : t.src,
              media: `(max-width: ${g - 1}px)`
            }
          ),
          /* @__PURE__ */ o(
            "img",
            {
              className: d,
              style: f,
              src: (i = (c = m == null ? void 0 : m.image) == null ? void 0 : c.pc) == null ? void 0 : i.src,
              alt: ((s = (l = m == null ? void 0 : m.image) == null ? void 0 : l.pc) == null ? void 0 : s.alt) ?? ""
            }
          )
        ]
      }
    ),
    m.children
  ] });
};
export {
  j as default
};
//# sourceMappingURL=Image.mjs.map
